import { Button, DeleteIcon, Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { SingleValue } from 'react-select';
import { useCreateNumbersSelectValues } from '../../../../hooks/useCreateNumbersSelectValues';
import { usePriorityOptions } from '../../../../hooks/usePriorityOptions';
import styles from '../../Constraints.module.scss';
import { ConstraintsFormInitialValuesType } from '../../types';

type MaxHoursConditionItemProps = {
  onRemove: () => void;
};

export const MaxOnUnknownPositionConstraintItem = ({ onRemove }: MaxHoursConditionItemProps) => {
  const { t } = useTranslation();

  const { setFieldValue, setFieldTouched, values } = useFormikContext<ConstraintsFormInitialValuesType>();

  const options = useCreateNumbersSelectValues();
  const priorityOptions = usePriorityOptions();

  const handleRemove = () => {
    setFieldValue('maxOnUnknownPosition', null);
    setFieldTouched('maxOnUnknownPosition', false);
    setFieldTouched('maxOnUnknownPositionPriority', false);
    setFieldValue('maxOnUnknownPositionPriority', null);
    onRemove();
  };

  return (
    <>
      <div className={styles['title']}>{t('conditions.maxHours.label')}</div>
      <div className={styles['row-wrapper']}>
        <div className='tks__row row-xs-11 mr-5'>
          <div className='tks__col col-xs-12'>
            <Select
              options={options}
              onChange={(value) => {
                const opt = value as SingleValue<SelectOptionType>;
                setFieldTouched('maxOnUnknownPosition', true);
                setFieldValue('maxOnUnknownPosition', opt?.value);
              }}
              value={options.find((o) => o.value === values.maxOnUnknownPosition) ?? null}
              label={t('common.maximum.short') as string}
              name={'maxOnUnknownPosition'}
            />
          </div>
        </div>
        <div className='tks__col col-xs-1'>
          <Select
            className={classNames(
              styles['priority-icon-select'],
              styles[`icon-${(values.maxOnUnknownPositionPriority ?? '').toLowerCase()}`],
            )}
            onChange={(value) => {
              const opt = value as SingleValue<SelectOptionType>;
              setFieldTouched('maxOnUnknownPositionPriority', true);
              setFieldValue('maxOnUnknownPositionPriority', opt?.value);
            }}
            options={priorityOptions}
            value={priorityOptions.find((option) => option.value === values.maxOnUnknownPositionPriority)}
            label={t('common.priority.full') as string}
            name={'maxOnUnknownPositionPriority'}
            fitMenuToOptions
            showIconOnly
          />
        </div>
        <div className={styles['button-wrapper']}>
          <Button name='remove' hierarchy='secondary' onClick={handleRemove} icon={<DeleteIcon />} />
        </div>
      </div>
    </>
  );
};
